/**
 * AdEventEmitter — minimal event emitter for ad player events.
 *
 * No external dependency. Pass an instance as the `emitter` prop to
 * VastOutstreamPlayer, then listen with .on(AdEvents.X, handler).
 */
export class AdEventEmitter {
  constructor() {
    this._listeners = {};
  }

  on(event, fn) {
    if (!this._listeners[event]) this._listeners[event] = [];
    this._listeners[event].push(fn);
    return this;
  }

  off(event, fn) {
    if (!this._listeners[event]) return this;
    this._listeners[event] = this._listeners[event].filter(f => f !== fn);
    return this;
  }

  emit(event, payload) {
    (this._listeners[event] || []).forEach(fn => {
      try { fn(payload); } catch (e) { console.error('[AdEventEmitter]', event, e); }
    });
  }
}
